export class WorkOrderReportIssueModel {
    public workOrderId: number;
    public receivers: { id: string, email: string }[];
    public subject: string;
    public body: string;
}
